module.exports = __webpack_public_path__ + "img/MC-Logo-Web-White.37ebdda.png";